import axios from "axios";
import { showToast } from "../store/actions";
import store from "../store";

const handleError = (error) => {
  if (error.response.status.toString().startsWith("5")) {
    if (error.response.status === 500)
      store.dispatch(showToast({ message: "Internal error occurred for requested operation!", type: "error" }));
    else if (error.response.status === 502 || error.response.status === 503)
      store.dispatch(showToast({ message: "The server is temporarily busy, try again later!", type: "error" }));
    else if (error.response.status === 504)
      store.dispatch(showToast({ message: "Time out for requested operation!", type: "error" }));
    else store.dispatch(showToast({ message: "Server error for requested operation!", type: "error" }));
  } else if (error.response.status !== 404) {
    const err = error.response.data;

    store.dispatch(showToast({ message: err.message ? err.message : "Something went wrong", type: "error" }));

    //reloading page when user does not have permission to perform some action
    if (error.response.status === 403) window.location.reload();
  }

  return error.response;
};

const fetchApi = {
  get: function (url, onSuccess) {
    return axios
      .get(url, {
        withCredentials: true,
      })
      .then(onSuccess)
      .catch(handleError);
  },

  post: function (url, data, onSuccess) {
    return axios
      .post(url, data, {
        withCredentials: true,
      })
      .then(onSuccess)
      .catch(handleError);
  },

  patch: function (url, data, onSuccess) {
    return axios
      .patch(url, data, {
        withCredentials: true,
      })
      .then(onSuccess)
      .catch(handleError);
  },

  delete: function (url, onSuccess) {
    return axios
      .delete(url, {
        withCredentials: true,
      })
      .then(onSuccess)
      .catch(handleError);
  },

  download: function (url, { fileName }, onSuccess) {
    return axios
      .get(url, {
        withCredentials: true,
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
        onSuccess && onSuccess();
      })
      .catch(handleError);
  },

  put: function (url, data, customHeaders = {}, customOptions = {}, onSuccess = null) {
    return axios
      .put(url, data, {
        headers: { ...customHeaders },
        ...(customOptions.onUploadProgress ? { onUploadProgress: customOptions.onUploadProgress } : {}),
      })
      .then(onSuccess)
      .catch((error) => error.response);
  },

  postFormData: function (url, formData, customHeaders = {}, customOptions = {}, onSuccess) {
    return axios
      .post(url, formData, {
        headers: {
          "Content-type": "multipart/form-data",
          ...customHeaders,
        },
        withCredentials: true,
        ...(customOptions.onUploadProgress ? { onUploadProgress: customOptions.onUploadProgress } : {}),
      })
      .then(onSuccess)
      .catch(handleError);
  },

  patchFormData: function (url, formData, customHeaders = {}, customOptions = {}, onSuccess) {
    return axios
      .patch(url, formData, {
        headers: {
          "Content-type": "multipart/form-data",
          ...customHeaders,
        },
        withCredentials: true,
        ...(customOptions.onUploadProgress ? { onUploadProgress: customOptions.onUploadProgress } : {}),
      })
      .then(onSuccess)
      .catch(handleError);
  },
};

export default fetchApi;
